// Catalyst event types offered as digest filters. Values must match the
// `type` field of indexed catalyst events.
export const CATALYST_EVENT_TYPES = [
  "Phase 1 Initiation",
  "Phase 1 Completion",
  "Phase 2 Initiation",
  "Phase 2 Completion",
  "Phase 3 Initiation",
  "Phase 3 Completion",
  "Phase 4 Initiation",
  "Phase 4 Completion",
  "Clinical Trial Data Readout",
  "Regulatory Submission",
  "Regulatory Meeting",
  "Regulatory Approval",
  "Orphan Drug Designation",
  "Fast Track Designation",
  "Breakthrough Therapy Designation",
  "Accelerated Approval Designation",
  "Complete Response Letter",
  "Regulatory Rejection",
  "Regulatory Approval Renewal",
  "Funding Round",
  "Public Offering",
  "Merger or Acquisition",
  "Strategic Partnership",
  "Licensing Agreement",
  "Company Spin-off",
  "Major Customer Order",
  "Government Grant",
  "Key Personnel Change",
  "Company Reorganization",
  "New Product Launch",
  "Market Expansion",
  "Market Entry",
  "Major Commercialization Milestone",
  "Patent Activity",
  "Technology Licensing Agreement",
  "Scientific Breakthrough",
  "Regulatory Investigation or Compliance Audit",
  "Intellectual Property Dispute",
  "Legal Settlement or Verdict",
  "Industry Award",
  "Market Perception Shift",
  "Regulatory Policy Change",
  "Major Scientific Presentation",
  "Participation in Industry Initiative",
  "Sustainability or CSR Announcement",
] as const;

export type CatalystEventType = (typeof CATALYST_EVENT_TYPES)[number];
